/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteEstate (id: number, params?: { force: boolean }) {
  return rest.delete(`/api/estates/${id}?${stringify(params)}`)
}

export function downloadEstateListFile (params: Record<string, any>) {
  return rest.post('/api/estates/download-list', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(params)
  }).then(handleBlobResponse)
}

export function fetchEstate (id: number): Promise<Estate> {
  return rest.get(`/api/estates/${id}`)
    .then((resp) => resp.json())
}

export function fetchEstateByReference (reference: string): Promise<Estate> {
  return rest.get(`/api/estates/by-reference/${reference}`)
    .then((resp) => resp.json())
}

export function findManyEstates (params?: Record<string, any>): Promise<HalDocument<{
  estates: Estate[]
}>> {
  return rest.get(`/api/estates?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchEstate (id: number, data: Partial<Estate>) {
  return rest.patch(`/api/estates/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postEstate (data: Partial<Estate>) {
  return rest.post('/api/estates', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function updateWatermarkOnEstatePhotos () {
  return rest.post('/api/estate-photos/update-watermark')
    .then((resp) => resp.json())
}
